import type { PoolsContentWrapperProps } from './Pools.types';

import { cn } from 'utils/cn';

const PoolsContentWrapper = ({
  children,
  className,
  ...rest
}: PoolsContentWrapperProps) => (
  <div
    className={cn(
      'max-w-133 relative box-border flex w-full flex-1 flex-col bg-blue-900',
      className
    )}
    {...rest}
  >
    <div className='flex h-full flex-col'>
      <div className='relative left-0 top-0 flex h-full w-full flex-col'>
        {children}
      </div>
    </div>
  </div>
);

export default PoolsContentWrapper;
